import React from "react";
import middleware from "../../../Api/Middleware";
import Placeholder from "../../Icons/empty-placeholder.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage, faCloudArrowUp } from "@fortawesome/free-solid-svg-icons";

const HouseStyle = ({ companyInfo }) => {
    return <div className="p-4 pb-0 w-50 parentCompanyInfoColumn">
        {companyInfo.font &&
            <div className="d-flex justiy-content-between pb-4">
                <h6 className="w-50 fw-bold">Lettertype</h6>
                <h6 className="w-50">{companyInfo.font}</h6>
            </div>
        }
        <div className="d-flex justiy-content-between pb-4">
            <h6 className="w-50 fw-bold">Logo</h6>
            {companyInfo.logo ? (
                <img 
                    src={`${middleware.defaults.imagesBaseURL}${companyInfo.logo}` ?? Placeholder} 
                    alt="Logo" 
                    style={{maxWidth: "15vw", maxHeight: "15vh"}}
                />
            ) : (
                <div className="text-muted d-flex align-items-center gap-2">
                    <FontAwesomeIcon icon={faCloudArrowUp} />
                    <span>Logo nog niet toegevoegd</span>
                </div>
            )}
        </div>
        <div className="d-flex justiy-content-between pb-4">
            <h6 className="w-50 fw-bold">Zwart logo witte achtergrond (voor thermische printers)</h6>
            {companyInfo.blackwhite_logo ? (
                <img 
                    src={`${middleware.defaults.imagesBaseURL}${companyInfo.blackwhite_logo}` ?? Placeholder} 
                    alt="Thermal Logo" 
                    style={{maxWidth: "15vw", maxHeight: "15vh"}} 
                />
            ) : (
                <div className="text-muted d-flex align-items-center gap-2">
                    <FontAwesomeIcon icon={faImage} />
                    <span>Thermisch logo ontbreekt</span>
                </div>
            )}
        </div>
    </div>
}

export default HouseStyle;